module.exports = __webpack_public_path__ + "img/help-center.f48e4f8b.png";